import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { http, searchFun } from '@/utils'
import moment from 'moment'
import { message } from 'antd'


class Store {
  DevCode = ""
  subset = ""
  list = []
  key = 0
  constructor() {
    makeAutoObservable(this)
  }

  get_list = async (subset, DevCode) => {
    this.DevCode = DevCode
    this.subset = subset
    const res = await http.get(`coopapi/device/getdevstatus`, {
      params: {
        subset, DevCode
      }
    })

    if (res.data.code === 400) { message.info(res.data.msg); return }


    runInAction(() => {
      this.key = new Date().getTime()
      this.list = res.data.data || []
    })
  }

  onFinish = async (v) => {
    console.log(v);


    let res = await http.put(`coopapi/device/setdevproperty`,
      {
        subset: v.item.subset,
        DevCode: this.DevCode,
        code: v.item.code,
        value: v.value
      })

    message.info(res.data.msg);
    if (res.data.code && res.data.code === 200) {
      // this.get_list()
      // message.info(res.data.msg);
    }

  }

  del = async (v) => {
    console.log(v);

    let res = await http.delete(`adminapi/order/` + v)
    message.info(res.msg);
    if (res.code === 200) { this.get_list() }

  }


  setks(obj) {
    for (let k in obj) {
      this[k] = obj[k]
    }
  }




}

export default new Store()